import { Search } from "@mui/icons-material";
import { InputAdornment, styled, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useIsMobile } from "../../hook/useIsMobile";

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})(({ isMobile }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "40px",
    backgroundColor: "#E9EEF0",
    height: "40px",
  },
  "& .MuiOutlinedInput-input": {
    "&::placeholder": {
      fontWeight: 400,
      fontSize: "16px",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  width: isMobile ? "100%" : "305px",
}));

const SearchInput = ({ placeholder, onSearch, value: externalValue }) => {
  const [searchValue, setSerachValue] = useState(externalValue || "");
  const isMobile = useIsMobile();

  useEffect(() => {
    setSerachValue(externalValue || "");
  }, [externalValue]);

  const handleChange = (event) => {
    const value = event.target.value;
    setSerachValue(value);
    onSearch(value);
  };
  return (
    <StyledTextField
      id="search-input"
      placeholder={placeholder}
      value={searchValue}
      onChange={handleChange}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        },
      }}
      variant="outlined"
      isMobile={isMobile}
    ></StyledTextField>
  );
};

export default SearchInput;
